let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../../../utils/FormUtils");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let getUsernameOptions = require("./getUsernameOptions");

let getMasterTodoListsForEvent = function (event, Displaylists) {

  let todolists;
  if (AuthedUserSession.is_st_family) {
    //TEAM-ADMIN privatelabels that use only shared actionlists
    todolists = _.get(Displaylists, ["universal", "todolists", _.get(event, "company_id"), "lists"], []);
  } else {
    //NORMAL per-speaker actionlists
    todolists = _.flattenDeep(_.map(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
      return _.includes(event && _.get(event, ["sids"]), _.get(spkr, ["sid"]));
    }), "todolists"));
  }

  let event_todolist_ids = _.map(event && event.todolistids, "listid");
  let todolist = _.flattenDeep(_.filter(todolists, function (todolist) {
    return _.includes(event_todolist_ids, _.get(todolist, ["id"]));
  }));
  if (!todolist) {
    todolist = _.flattenDeep(_.filter(todolists, function (todolist) {
      return 0 === _.get(todolist, ["id"]);
    }));
  }
  return _.object(_.flatten(_.map(todolist, function (list) {
    return _.map(list.masters, function (master, id) {
      return [id, master];
    });
  })));

};

module.exports = dd.createClass({
  mixins: [FormMixin],
  getInitialValuesSourceVersion(props) {
    return esUtils.getEventVersionIdentifier(props.event);
  },
  buildSchema() {
    let {event, Displaylists} = this.props;
    return {
      description: {
        label: "Item description",//For the validation method
        type: "combo",
        options: _.mapValues(getMasterTodoListsForEvent(event, Displaylists), "description"),
        validate: FormUtils.v.required
      },
      statusdate: {
        type: "date",
        dropup: true
      },
      assignedto: {
        type: "select",
        options: getUsernameOptions(event),
        placeholder: "--",
        validate: FormUtils.v.optional
      }
    };
  },
  onFormChanged(field_path, new_value) {
    if (field_path === "description") {
      let {event, Displaylists} = this.props;
      let master_lists = getMasterTodoListsForEvent(event, Displaylists);
      let master_list = master_lists[new_value];
      if (event && master_list) {
        let data = this.state.data || {};
        data.description = master_list.description;
        if (master_list.duebasedon === "STRT") {//STRT - event start date
          data.statusdate = _.isDate(event.starttime) ? new Date(event.starttime.getTime()) : new Date();
        } else if (master_list.duebasedon === "STAT") {//STAT - event create date
          data.statusdate = _.isDate(event.created) ? new Date(event.created.getTime()) : new Date();
        } else {
          data.statusdate = null;
        }
        if (_.isDate(data.statusdate) && _.isNumber(master_list.duedelta) && !_.isNaN(master_list.duedelta)) {
          data.statusdate.setDate(data.statusdate.getDate() + master_list.duedelta);
        }
        data.assignedto = _.isString(master_list.assignedto) ? master_list.assignedto : "";
        data.assignedto = data.assignedto.replace(/\[ME\]/i, AuthedUserSession.MY_USERNAME);
        this.setState({data});
      }
    }
  },
  render() {
    let fields = this.Form_buildSchema();
    let errors = this.state.errors || {};
    let buildInput = this.Form_buildInput;

    let buildField = function (name) {
      return dd.div({className: errors[name] ? "has-error" : null},
        buildInput(fields[name]),
        errors[name] ? dd.span({className: "help-block"}, errors[name]) : null
      );
    };

    return dd.form({className: "NewActionItemForm", onSubmit: this.Form_onSubmit},
      dd.table({style: {width: "100%"}},
        dd.thead(null,
          dd.tr(null,
            dd.th({style: {fontWeight: "normal"}}, "Add New Action"),
            dd.th({style: {fontWeight: "normal", width: "10em"}}, "Due On"),
            dd.th({style: {fontWeight: "normal", width: "7em"}}, "Assigned To"),
            dd.th({style: {fontWeight: "normal", width: 1}})
          )
        ),
        dd.tbody(null,
          dd.tr(null,
            dd.td(null, buildField("description")),
            dd.td(null, buildField("statusdate")),
            dd.td(null, buildField("assignedto")),
            dd.td(null, dd.button({type: "submit", className: "btn btn-default"},
              dd.i({className: "fa fa-plus"}), " Add"
            ))
          )
        )
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/NewActionItemForm.js